module.exports = __webpack_public_path__ + "img/programmer-and-coding-concept.be3b7762.webp";